// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2GEXV","name":"ConsentHeader_name__3591I","birthday":"ConsentHeader_birthday__36pfx","skeleton":"ConsentHeader_skeleton__1IGnY"};